<template>
	<!--mobile-->
  <div>
	<div v-if="$flag" class="bmenu-box"  >
       <div class="round-box"></div>
       <div class="menu-box">
         <div class="mlbox" :class="tnum==0?'nav_act':''">
           <router-link tag="a" to='/insp/sindex' >
             <div class="mt-10">
               <img v-if="tnum==0" class="menu-img" src="../assets/images/center-act.png">
               <img v-else class="menu-img" src="../assets/images/center.png">
             </div>
             <div class="menu-text ins_center_menu">验货广场</div>
           </router-link>
         </div>
         <div class="mmbox">
           <router-link tag="a" to='/index/wantOrder' >
               <div class="add-bnt">
                 <img class="add-img" src="../assets/images/madd.png">
               </div>
           </router-link>
         </div>
         <div class="mrbox ">
             <div class="mt-10">
               <img class="menu-img" src="../assets/images/msg.png">
             </div>
             <div class="menu-text">消息</div>
         </div>
         <div class="no-new-read hide">0</div>

       </div>
	</div>

  </div>

</template>

<script>

	export default {
		name: "bMenu",
		props: {
      tnum: {
        type: Number,
        default: 0
      }
		},
		data() {
			return {

			};
		},
		computed: {
			 
		},
		watch: {
			 
		},
		methods: {


			 
		},
		mounted() {
		 
		},
		created() {

		},
		destroyed() {

		}
	};
</script>
<style scoped lang="scss">
@import "../assets/css/animate.min.css";
@import "../assets/css/own.css";
</style>